import { windowEvents } from "../constants/custom_events";

const CustomEvents = {
  on: (event, callback) => {
    if (!Object.values(windowEvents).includes(event))
      throw new Error(`${event} is not a valid custom event`);
    window.addEventListener(event, callback);
  },
};
Object.keys(windowEvents).forEach((event) => {
  CustomEvents[windowEvents[event]] = (data = {}) => {
    const dispatchEvent = new Event(windowEvents[event], { detail: data });
    console.log(dispatchEvent);
    window.dispatchEvent(dispatchEvent);
  };
});
export const Events = windowEvents;
export default CustomEvents;
